export default __webpack_public_path__ + "static/media/specializedCenterIcon.7c98fc38.svg";